import userCommitTypes from './commit-types';
import userModel from '../../models/user';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_USER_STATE = {
  isAddingUser: false,
  isEditingUser: null,
  isEditingUserRoles: false,
  isLoading: [],
  list: null,
  selectedGuid: null,
  validationErrors: null,
  usersByMaster: []
};

function userReducers(state = INITIAL_USER_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case userCommitTypes.CREATE_USER_SUCCESS:
      return { ...state };
    case userCommitTypes.PUSH_USER_VALIDATION_ERRORS:
      // Always replace these as this key is populated from an API call, and we don't want
      //   to report errors from a previous API call
      return {
        ...state,
        validationErrors: [...action.validationErrors],
      };
    case userCommitTypes.PUSH_USER:
      return {
        ...state,
        list: !state.list
          ? [userModel(action.user)]
          : [userModel(action.user), ...state.list],
      };
    case userCommitTypes.PUSH_USERS:
      return {
        ...state,
        list: [...action.list.map(item => userModel(item))],
      };
    case userCommitTypes.PUSH_USERS_BY_MASTER:
      return {
        ...state,
        usersByMaster: [...action.list.map(item => userModel(item))],
      };
    case userCommitTypes.REPLACE_USER:
      return {
        ...state,
        list: [
          ...ReducerUtilities.replaceModelInList(
            userModel(action.user),
            state.list,
          ),
        ],
      };
    case userCommitTypes.UPDATE_USER_ACTIVE:
      return {
        ...state,
        list: [
          ...ReducerUtilities.replaceModelInList(
            userModel(action.user),
            state.list,
          ),
        ],
      };
    case userCommitTypes.RESET_USER_STATE:
      return { ...INITIAL_USER_STATE };
    case userCommitTypes.SET_IS_ADDING_OIT:
      return {
        ...state,
        isAddingOit: action.isAddingOit,
      };
    case userCommitTypes.SET_IS_ADDING_USER:
      return {
        ...state,
        isAddingUser: action.isAddingUser,
      };
    case userCommitTypes.SET_IS_ADDING_USER_ADDRESS:
      return {
        ...state,
        isAddingAddress: action.isAddingAddress,
      };
    case userCommitTypes.SET_IS_ADDING_USER_PHONE:
      return {
        ...state,
        isAddingPhone: action.isAddingPhone,
      };
    case userCommitTypes.SET_IS_EDITING_USER:
      return {
        ...state,
        isEditingUser: action.isEditingUser,
      };
    case userCommitTypes.SET_IS_EDITING_USER_ADDRESS:
      return {
        ...state,
        isEditingAddress: action.isEditingAddress,
      };
    case userCommitTypes.SET_IS_EDITING_USER_PHONE:
      return {
        ...state,
        isEditingPhone: action.isEditingPhone,
      };
    case userCommitTypes.SET_IS_EDITING_USER_ROLES:
      return {
        ...state,
        isEditingUserRoles: action.isEditingUserRoles,
      };
    case userCommitTypes.SET_USER_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case userCommitTypes.SET_SELECTED_USER_GUID:
      return {
        ...state,
        selectedGuid: action.selectedGuid,
      };
    default:
      return state;
  }
}

export default userReducers;
